import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Invoices from "./Invoices";
import Footer from "./Footer";
const UserInvoices = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <Invoices />
      <Footer />
    </>
  );
};

export default UserInvoices;
